import React from 'react';
import { PRIMARY } from '../../../../theme';
export var Mountain = function Mountain(props) {
  var fillColor = props.color || PRIMARY;
  return /*#__PURE__*/React.createElement("svg", {
    width: "42",
    height: "42",
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3747 42H0.874698C0.566698 42 0.279698 41.8373 0.122198 41.5713C-0.0353017 41.3053 -0.0405517 40.9763 0.106448 40.705L15.8564 11.83C16.1627 11.2683 17.0867 11.2683 17.393 11.83L33.143 40.705C33.29 40.9763 33.2847 41.3053 33.1272 41.5713C32.9697 41.8373 32.6827 42 32.3747 42ZM2.3482 40.25H30.8995L16.6247 14.077L2.3482 40.25Z",
    fill: fillColor,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1258 42H32.3758C31.8928 42 31.5008 41.608 31.5008 41.125C31.5008 40.642 31.8928 40.25 32.3758 40.25H39.6453L31.5516 25.5325L28.2161 32.4345C28.0061 32.8685 27.4863 33.0522 27.0471 32.8405C26.6113 32.6305 26.4293 32.1072 26.6411 31.6715L30.7151 23.2435C30.8586 22.9495 31.1526 22.7587 31.4798 22.75C31.8088 22.7657 32.1116 22.9162 32.2691 23.2032L41.8941 40.7032C42.0428 40.9745 42.0393 41.3035 41.8801 41.5695C41.7208 41.8372 41.4356 42 41.1258 42Z",
    fill: fillColor,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.625 13.125C16.142 13.125 15.75 12.733 15.75 12.25V0.875C15.75 0.392 16.142 0 16.625 0H27.125C27.4785 0 27.7988 0.2135 27.9335 0.54075C28.07 0.868 27.9948 1.24425 27.7445 1.4945L24.8623 4.375L27.7428 7.2555C27.993 7.50575 28.0683 7.882 27.9318 8.20925C27.7988 8.5365 27.4785 8.75 27.125 8.75H17.5V12.25C17.5 12.733 17.108 13.125 16.625 13.125ZM17.5 7H25.0128L23.0073 4.9945C22.666 4.65325 22.666 4.0985 23.0073 3.75725L25.0128 1.75H17.5V7Z",
    fill: fillColor,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2492 26.25C19.2282 26.25 19.209 26.25 19.1862 26.2483C18.9325 26.2308 18.7015 26.103 18.5492 25.9L16.6242 23.3345L14.6992 25.9C14.547 26.103 14.3142 26.229 14.0622 26.2483C13.798 26.2693 13.56 26.1748 13.3815 25.9945L10.4415 23.0545C10.1002 22.7133 10.1002 22.1585 10.4415 21.8173C10.7827 21.476 11.3375 21.476 11.6787 21.8173L13.9047 24.0433L15.9242 21.35C16.2532 20.909 16.9935 20.909 17.3242 21.35L19.3437 24.0433L21.5697 21.8173C21.911 21.476 22.4657 21.476 22.807 21.8173C23.1482 22.1585 23.1482 22.7133 22.807 23.0545L19.867 25.9945C19.7025 26.159 19.4802 26.25 19.2492 26.25Z",
    fill: fillColor,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "42",
    height: "42",
    fill: "none"
  }))));
};